import { useState } from 'react';
import { getPlayerAvatar } from '../../utils/player';
import ModalCloseButton from './ModalCloseButton';

const EditSessionModal = ({
  session,
  allPlayers,
  onClose,
  onSave,
  onDelete,
}) => {
  const [stats, setStats] = useState(() =>
    JSON.parse(JSON.stringify(session.sessionStats))
  );
  const [sessionDate, setSessionDate] = useState(session.date);
  const [isRanked, setIsRanked] = useState(session.ranked !== false); // Default to true if not set

  const handleStatChange = (playerName, field, value) => {
    const numericValue = Math.max(0, parseInt(value, 10) || 0);
    setStats((prevStats) => ({
      ...prevStats,
      [playerName]: {
        ...prevStats[playerName],
        [field]: numericValue,
      },
    }));
  };

  const handleSave = () => {
    onSave(session.id, session.sessionStats, stats, sessionDate, session.sessionHistory, isRanked);
  };

  const sortedPlayers = Object.entries(stats).sort(([playerA], [playerB]) =>
    playerA.localeCompare(playerB)
  );

  return (
    <div className="modal-overlay">
      <div className="modal modal-wide">
        {onDelete && (
          <button
            onClick={onDelete}
            className="modal-delete"
            aria-label="Delete session"
          >
            <span className="material-symbols-outlined" style={{ fontSize: '24px' }}>
              delete
            </span>
          </button>
        )}
        <ModalCloseButton onClick={onClose} />
        <h3 className="modal-title">
          Edit Session Stats:{' '}
          <span className="card-content text-base">{session.date}</span>
        </h3>

        <div className="modal-content mb-lg">
          <label className="block caption font-medium card-content text-left mb-sm">
            Session Date
          </label>
          <input
            type="text"
            placeholder="DD/MM/YYYY"
            value={sessionDate}
            onChange={(e) => setSessionDate(e.target.value)}
            className="input mb-md"
          />
          
          <label className="flex items-center gap-sm cursor-pointer">
            <input
              type="checkbox"
              checked={isRanked}
              onChange={(e) => setIsRanked(e.target.checked)}
              className="checkbox"
            />
            <span className="body">Ranked session</span>
          </label>
          <p className="caption text-left mt-xs" style={{ color: 'var(--on-surface-variant)' }}>
            Unranked sessions are excluded from overall stats and event leaderboards
          </p>
        </div>

        <div className="overflow-x-auto max-h-96">
          <table className="table">
            <thead className="sticky top-0">
              <tr>
                <th>Player</th>
                <th className="text-center">Wins (W)</th>
                <th className="text-center">Losses (L)</th>
              </tr>
            </thead>
            <tbody>
              {sortedPlayers.map(([playerName, data]) => (
                <tr key={playerName}>
                  <td>
                    <div className="flex items-center gap-sm">
                      <img
                        src={getPlayerAvatar(allPlayers, playerName)}
                        alt={`${playerName}'s avatar`}
                        className="avatar avatar-sm"
                      />
                      <span>{playerName}</span>
                    </div>
                  </td>
                  <td className="text-center">
                    <input
                      type="number"
                      min="0"
                      value={data.wins}
                      onChange={(e) => handleStatChange(playerName, 'wins', e.target.value)}
                      className="w-16 p-1 border border-gray-300 dark:border-gray-600 rounded-lg text-center bg-white dark:bg-gray-800 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </td>
                  <td className="text-center">
                    <input
                      type="number"
                      min="0"
                      value={data.losses}
                      onChange={(e) => handleStatChange(playerName, 'losses', e.target.value)}
                      className="w-16 p-1 border border-gray-300 dark:border-gray-600 rounded-lg text-center bg-white dark:bg-gray-800 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <button
          onClick={handleSave}
          className="btn btn-primary btn-full mt-lg"
        >
          <span className="btn-text">SAVE CHANGES</span>
        </button>
      </div>
    </div>
  );
};

export default EditSessionModal;

